export const splitOnLines = (text: string): string[] => text.split('\n')
